// Deployed dev-cloud environment (https://hotelb2b.dev.hilbertech.com), built via the
// Angular "development" configuration on the ADO `dev` branch pipeline. Distinct from
// environment.ts (localhost:4211 + proxy.conf.json + fake devAgencyToken bypass) because a
// deployed static site has no dev-server proxy and the real dev backends behind APIM don't
// accept the unsigned local JWT.
export const environment = {
  production: false,
  // Real dev backends validate the B2C token for real — no fake-JWT bypass like environment.ts.
  // Milestone 2: auth.interceptor.ts attaches the real MSAL access token when skipAuth is false.
  // be-agency-service is the one BE that may enforce real oidc validation outside local — its
  // audience/issuer compatibility with this app registration is UNVERIFIED until tested here.
  skipAuth: false,
  apiAgencyUrl: 'https://apim-dev-hilbertec.azure-api.net/agency/api',
  apiUserUrl: 'https://apim-dev-hilbertec.azure-api.net/user/api',
  // Confirmed 2026-07-09 via `az apim api operation list` against apim-dev-hilbertec: the
  // registered operations are `/api/extranet/...` (mirrors apiFlightSearchUrl's `search/api`
  // pattern below) — the base was missing the `/api` segment, which meant every call from
  // hotel-sourcing.service.ts (e.g. `${base}/extranet/reservations`) 503'd at the gateway
  // before ever reaching be-hotel-extranet-service.
  apiExtranetUrl: 'https://apim-dev-hilbertec.azure-api.net/hotels/extranet/api',
  apiUtilsUrl: 'https://apim-dev-hilbertec.azure-api.net/utils',
  // Confirmed live 2026-07-05 via direct curl against APIM (real Amadeus-shaped response,
  // e.g. GET .../search/api/hotels/search?cityCode=...) — mirrors flight-fusion's own
  // environment.dev.ts pattern (`search/api/`) for the same backend.
  apiFlightSearchUrl: 'https://apim-dev-hilbertec.azure-api.net/search/api',
  // be-flight-reservation-service behind APIM — mirrors fe-flight-fusion-web's own
  // environment.dev.ts pattern (`reservation/api/`) for the same backend.
  apiFlightReservationUrl: 'https://apim-dev-hilbertec.azure-api.net/reservation/api',
  devAgencyToken: '',
  // TODO: confirm whether dev has its own bucket; reusing the prod CDN URL until then.
  cdnBaseUrl: 'https://hotel-extranet.fra1.cdn.digitaloceanspaces.com',
  msalConfig: {
    // Same app registration as environment.ts (local) — just a second SPA redirect URI added
    // for this domain, mirroring how flight-fusion reuses one clientId across local + dev-cloud.
    clientId: '33c9e7f9-accc-4968-a948-b60cbc76b529',
    authority: 'https://b2bdevhilbertech.b2clogin.com/b2bdevhilbertech.onmicrosoft.com/B2C_1_Hotel-b2b-portal',
    knownAuthorities: ['b2bdevhilbertech.b2clogin.com'],
    redirectUri: 'https://hotelb2b.dev.hilbertech.com',
    postLogoutRedirectUri: 'https://hotelb2b.dev.hilbertech.com',
  },
  // Requires "Expose an API" configured on this app registration with a scope named
  // `api.access` (mirroring flight-fusion) — see environment.local.ts for the same setup.
  apiScopes: ['https://b2bdevhilbertech.onmicrosoft.com/33c9e7f9-accc-4968-a948-b60cbc76b529/api.access'] as string[],
};
